import React from "react";
import Card from "../card";
import { PhotoLoading, DummyGrid, DummyAddress, DummyPrice, DummyAddressSecondary, DummyStatus, DummyDetails, DummyTimestamp, Left, Right, DummyIcon } from "./styled/listing-card-loading";
function ListingCardLoading(_a) {
    var showFooter = _a.showFooter;
    return (React.createElement(Card, null,
        React.createElement(Card.Header, null,
            React.createElement(PhotoLoading, null)),
        React.createElement(Card.Body, null,
            React.createElement(DummyGrid, null,
                React.createElement(DummyAddress, null),
                React.createElement(DummyPrice, null)),
            React.createElement(DummyGrid, null,
                React.createElement(DummyAddressSecondary, null),
                React.createElement(DummyStatus, null)),
            React.createElement(DummyGrid, null,
                React.createElement(DummyDetails, null),
                React.createElement(DummyTimestamp, null))),
        showFooter && (React.createElement(Card.Footer, null,
            React.createElement(Left, null,
                React.createElement(DummyIcon, null),
                React.createElement(DummyIcon, null),
                React.createElement(DummyIcon, null)),
            React.createElement(Right, null,
                React.createElement(DummyIcon, null))))));
}
export default ListingCardLoading;
